<template>
    <div>
        <div id="map" class="w-100 min-vh-50 mb-4"></div>
        <div class="row">
            <transition-group name="fade" class="row mt-3">
                <div
                    v-for="location in locations"
                    :key="location.id"
                    class="col-md-3 col-6 mb-3"
                >
                    <div class="p-3 bg-light" v-html="location.infoHtml"></div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      config: config,
      locations: data_locations,
      data_locations: data_locations,
      locationIds: [],
      markers: [],
      map: null,
      activeInfoWindow: null,
    };
  },
  mounted() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      zoom: config.locations_map.default_zoom,
      center: { lat: config.locations_map.default_lat, lng: config.locations_map.default_lng },
    //   mapTypeId: "hybrid",
      clickableIcons: false,
    });
    this.setMarkers();
    const vue = this;
    this.map.addListener("center_changed", function () {
      vue.filterByMarkers();
    });
    this.map.addListener("zoom_changed", function () {
      vue.filterByMarkers();
    });
  },
  computed: {},
  methods: {
    filterByMarkers() {
      this.locationIds = [];
      for (var i = 0; i < this.markers.length; i++) {
        if (this.map.getBounds().contains(this.markers[i].getPosition())) {
          this.locationIds.push(this.markers[i].id)
        }
      }
      this.locations = this.data_locations.filter((location) => {
        return this.locationIds.includes(location.id)
      });
    },
    setMarkers() {
      const vue = this
      this.locations.forEach((location, index) => {
        this.markers[index] = new google.maps.Marker(location)

        var infowindow = new google.maps.InfoWindow({
          content: location.infoHtml,
        })

        google.maps.event.addListener(
          this.markers[index],
          "click",
          function () {
            if (vue.activeInfoWindow) {
              vue.activeInfoWindow.close()
            }
            infowindow.open(vue.map, vue.markers[index])
            vue.activeInfoWindow = infowindow
            vue.map.setCenter(vue.markers[index].position)
            vue.map.setZoom(20)
          }
        )
        this.markers[index].setMap(this.map)
      })
    },
  },
};
</script>
